import request from '@/utils/request'

/**
 * 查询船舶航迹数据
 * @param {Object} params 查询参数
 * @param {string} [params.keyword] 搜索关键词(船舶名称或MMSI号)
 * @param {string} params.startTime 开始时间，格式：YYYY-MM-DDTHH:mm:ss
 * @param {string} params.endTime 结束时间，格式：YYYY-MM-DDTHH:mm:ss
 * @param {number} [params.pageNum=1] 页码
 * @param {number} [params.pageSize=10] 每页条数
 * @returns {Promise<{
 *   code: number,
 *   message: string,
 *   data: {
 *     list: Array<{
 *       mmsi: string,
 *       vesselName: string,
 *       vesselType: string,
 *       longitude: number,
 *       latitude: number,
 *       heading: number,
 *       speed: number,
 *       timestamp: string,
 *       isWarning: number,
 *       warningType: string
 *     }>,
 *     total: number,
 *     pageNum: number,
 *     pageSize: number
 *   }
 * }>} 分页的船舶航迹数据
 */
export function searchVesselTrajectory(params) {
  return request({
    url: '/vessel-trajectory/search',
    method: 'get',
    params
  })
}

/**
 * 根据MMSI号查询船舶最近航迹（用于实时尾迹渲染）
 * @param {string} mmsi 船舶MMSI号
 * @param {number} [minutes=30] 查询最近多少分钟内的数据
 * @param {number} [limit=50] 最大返回条数
 * @returns {Promise<{code: number, data: Array}>} 航迹数据列表（按时间升序）
 */
export function getRecentTrajectoryByMmsi(mmsi, minutes = 30, limit = 50) {
  return request({
    url: `/vessel-trajectory/${mmsi}`,
    method: 'get',
    params: { minutes, limit }
  })
}
